import { limitFill } from "@cloudinary/transformation-builder-sdk/actions/resize";
import { autoGravity } from "@cloudinary/transformation-builder-sdk/qualifiers/gravity";
import { Card, Text } from "@ttc3k/trekker";
import {
  ClickableCardSurface,
  CloudinaryImage,
  DoorstopCardProps,
} from "shared/components";
import { isLandscape } from "shared/utils";
import { css } from "styled-system/css";

type OrganizationDoorstopCardProps = Omit<DoorstopCardProps, "onClaimClick">;

export const OrganizationDoorstopCard = ({
  doorstopItem,
  onItemClick,
}: OrganizationDoorstopCardProps) => {
  const { image, name } = doorstopItem;
  return (
    <ClickableCardSurface
      onClick={() => onItemClick?.(doorstopItem)}
      flex="1"
      height="140px"
      minWidth="200px"
    >
      <Card.Body
        display="flex"
        flexDir="row"
        justifyContent={"center"}
        alignItems="center"
      >
        {image ? (
          <CloudinaryImage
            image={image}
            imageStyleProps={{
              objectFit: "scale-down",
              className: css({
                maxH: "80px",
                maxW: "160px",
              }),
            }}
            resize={
              isLandscape(image)
                ? limitFill().width(160).gravity(autoGravity())
                : limitFill().height(80).gravity(autoGravity())
            }
            alt={name}
          />
        ) : (
          <Text visual="bodySemiBold">{name}</Text>
        )}
      </Card.Body>
    </ClickableCardSurface>
  );
};
